//@ts-nocheck
import { format } from 'date-fns';
import { getStatusByCode } from '../../../utils/tripStatusesHelper';
import { XGChip } from 'xg-cl';
import { utcToZonedTime } from 'date-fns-tz';
import { Link } from 'react-router-dom';

export const tripsColumns = [
  { field: 'id', headerClassName: 'tripsList__column-headers' },
  {
    field: 'title',
    sortable: true,
    headerName: 'Title',
    headerClassName: 'trips-list__data-grid-header',
    cellClassName: 'trips-list__data-grid-header-title',
    flex: 2,
    renderCell: (params) => {
      return (
        <Link
          to={`/trips/${params.id}`}
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          {params.value}
        </Link>
      );
    }
  },
  {
    field: 'status',
    sortable: true,
    headerName: 'Status',
    width: 150,
    headerClassName: 'trips-list__data-grid-header',
    flex: 1,
    renderCell: (params) => {
      const statusData = getStatusByCode(params.value);
      return (
        <XGChip
          className={`${statusData?.customClass}`}
          id={`${params.value}-chip`}
          text={statusData?.tripstatusname}
          type={statusData.type}
          variant='outlined'
          size={statusData?.size}
          style={{ borderRadius: '6px', height: '18px' }}
        />
      );
    }
  },
  {
    field: 'destination',
    sortable: true,
    headerName: 'Destination',
    width: 170,
    headerClassName: 'trips-list__data-grid-header',
    flex: 1
  },
  {
    field: 'startDate',
    sortable: true,
    headerName: 'Start date',
    width: 210,
    headerClassName: 'trips-list__data-grid-header',
    flex: 1
  },
  {
    field: 'lastModified',
    sortable: true,
    headerName: 'Last modified',
    width: 210,
    headerClassName: 'trips-list__data-grid-header',
    flex: 1,
    renderCell: (params) => {
      try {
        return format(
          utcToZonedTime(new Date(params.value), 'UTC'),
          'dd MMM yyyy',
          { timeZone: 'UTC' }
        );
      } catch (error) {
        return params.value;
      }
    }
  },
  {
    field: 'createdByUser',
    sortable: true,
    headerName: 'Created by',
    width: 170,
    headerClassName: 'trips-list__data-grid-header',
    flex: 1,
    renderCell: (params) => {
      return `${params.value.firstname || ''} ${params.value.lastname || ''}`.trim();
    }
  }
];
